import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetMeQuery } from '@/app/services/nucleus';

// admin/superadmin implicitly satisfy any lower-tier role, mirroring the sidebar's hasPermissions check.
const satisfiesRole = (user, role) => {
  if (role === 'superadmin') return !!user?.superadmin;
  if (role === 'admin') return !!user?.admin || !!user?.superadmin;
  return !!user?.roles?.includes(role) || !!user?.admin || !!user?.superadmin;
};

/**
 * Redirects to /401 unless the user satisfies at least one of the given role(s).
 * Accepts a single role string or an array of roles (any-of / OR), consistent with
 * the sidebar's permission logic.
 *
 * @param {string|string[]} role
 */
export const useRole = (role) => {
  const navigate = useNavigate();
  const { data: user, isSuccess: isGetUserSuccess } = useGetMeQuery();

  useEffect(() => {
    const requiredRoles = Array.isArray(role) ? role : [role];
    const authorized = requiredRoles.some((r) => satisfiesRole(user, r));
    if (user && !authorized) {
      navigate('/401');
    }
  }, [isGetUserSuccess]);

  return null;
};
